import {
  FaArrowTrendUp,
  FaBriefcase,
  FaMoneyBillWave,
  //   FaShieldAlt,
} from "react-icons/fa6";

const benefits = [
  {
    id: 1,
    title: "High Demand",
    description:
      "Organizations worldwide are facing a massive shortage of skilled security experts.",
    icon: FaArrowTrendUp,
    iconColor: "text-amber-600",
  },
  {
    id: 2,
    title: "Career Growth",
    description:
      "Cybersecurity offers a clear path from entry-level to high-end executive roles.",
    icon: FaBriefcase,
    iconColor: "text-blue-600",
  },
  {
    id: 3,
    title: "Attractive Pay",
    description:
      "Security professionals are among the highest-paid individuals in the tech industry.",
    icon: FaMoneyBillWave,
    iconColor: "text-amber-600",
  },
  {
    id: 4,
    title: "Future-Proof",
    description:
      "As long as technology exists, the need for security will only continue to increase.",
    icon: FaMoneyBillWave,
    iconColor: "text-blue-600",
  },
];

export default function WhyCybersecurity() {
  return (
    <section className="bg-[#f5f6fa] py-24">
      <div className="mx-auto lg:px-28 md:px-14 px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-[#12105E] md:text-4xl">
            Why Cybersecurity?
          </h2>

          <p className="mt-4 text-lg leading-relaxed text-slate-500">
            The world is more connected than ever, making digital security the
            most critical field of the century.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {benefits.map((item) => {
            const Icon = item.icon;

            return (
              <div
                key={item.id}
                className="
                  rounded-2xl
                  border
                  border-slate-200
                  bg-transparent
                  p-6
                  shadow-sm
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:shadow-lg
                "
              >
                <Icon className={`${item.iconColor} text-2xl`} />

                <h3 className="mt-5 text-xl font-bold text-slate-900">
                  {item.title}
                </h3>

                <p className="mt-3 text-sm leading-7 text-slate-500">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
